__turbopack_context__.v({
  "logo": "BrandLogo-module-scss-module__ImjBLa__logo",
  "small": "BrandLogo-module-scss-module__ImjBLa__small",
  "small-logo": "BrandLogo-module-scss-module__ImjBLa__small-logo",
  "wrapper": "BrandLogo-module-scss-module__ImjBLa__wrapper",
});
